import React from 'react'
import { Shield } from 'lucide-react'
import { useLanguage } from '../i18n'

const Footer = () => {
  const { t } = useLanguage()

  return (
    <footer className="tech-header border-t border-titanium-gold/20 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center tech-subtitle">
          <p>{t('footer.copyright')}</p>
          <p className="text-sm mt-2 flex items-center justify-center space-x-2">
            <Shield className="w-4 h-4" />
            <span>{t('footer.tagline')}</span>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
